import ethereum from 'decentralized/ethereum.js';
import sequenceMetadata from 'decentralized/sequences/SequenceMetadata.js';

export async function getNotes(id, checkSequences=true) {
    if (id === undefined) {
        return undefined;
    }
    let notes = await ethereum.messaging.getMessages(
        id);
    
    let nextSequences = await ethereum.tokenizedSequences.getNextSequences(
        id);
    let previousSequences = []; // await ethereum.tokenizedSequences.getPreviousSequences(
//        id);
    let favorites = await sequenceMetadata.getFavorites(id);
    favorites = favorites.map(x => ({... x, isFavorite: true}));
    
    let fullNotes = checkSequences ?
        [... nextSequences, ... previousSequences, ...favorites, ... notes] :
        [... notes, ...favorites];
    fullNotes.sort((a, b) => b.blockNumber - a.blockNumber);
    return fullNotes;
}
